import { render, staticRenderFns } from "./EdocView.vue?vue&type=template&id=4c8fde7d"
import script from "./EdocView.vue?vue&type=script&lang=js"
export * from "./EdocView.vue?vue&type=script&lang=js"
import style0 from "./EdocView.vue?vue&type=style&index=0&id=4c8fde7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports